<template>
    <div class="posfinder-screen__loading" :class="loadingClass"></div>
</template>

<script>
    export default {
        name: "Spinner",
        props: {
            loading: Boolean,
            inline: Boolean,
            fixed: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            loadingClass() {
                const classes = [];
                if (this.inline) {
                    classes.push('posfinder-screen__loading--inline');
                }
                if (this.loading) {
                    classes.push('posfinder-screen__loading--visible');
                }
                if (!this.fixed) {
                    classes.push('posfinder-screen__loading--relative');
                }
                return classes.join(' ');
            }
        }
    }
</script>
